import { useState, useEffect } from 'react'
import { useOrganizationId } from './useOrganizationId'
import { hasFeatureAccess, getOrganizationFeatures } from '../services/featureGating'

/**
 * Hook to check if organization has access to a specific feature
 */
export const useFeatureAccess = (featureCode) => {
  const [hasAccess, setHasAccess] = useState(false)
  const [loading, setLoading] = useState(true)
  const organizationId = useOrganizationId()

  useEffect(() => {
    if (!organizationId || !featureCode) {
      setHasAccess(false)
      setLoading(false)
      return
    }

    const checkAccess = async () => {
      try {
        const access = await hasFeatureAccess(organizationId, featureCode)
        setHasAccess(access)
      } catch (error) {
        console.error('Error checking feature access:', error)
        setHasAccess(false)
      } finally {
        setLoading(false)
      }
    }

    checkAccess()
  }, [organizationId, featureCode])

  return { hasAccess, loading }
}

/**
 * Hook to get all available features for organization
 */
export const useOrganizationFeatures = () => {
  const [features, setFeatures] = useState([])
  const [loading, setLoading] = useState(true)
  const organizationId = useOrganizationId()

  useEffect(() => {
    if (!organizationId) {
      setFeatures([])
      setLoading(false)
      return
    }

    const fetchFeatures = async () => {
      try {
        const orgFeatures = await getOrganizationFeatures(organizationId)
        setFeatures(orgFeatures)
      } catch (error) {
        console.error('Error fetching organization features:', error)
        setFeatures([])
      } finally {
        setLoading(false)
      }
    }

    fetchFeatures()
  }, [organizationId])

  return { features, loading }
}

